<template>
  <div class="wt-container">
        <p class="introduction-text text-center">
          The annual {{cropText}}{{countryOrBasinText}}.
        </p>
        <div class="row mb-3">
          <label for="orderby" class="col-auto col-form-label">Order by</label>
          <div class="col-auto">
            <select v-model="orderPropertyName" @change="updateData()" id="orderby" class="form-select">
              <option :value="namePropertyName">name</option>
              <option value="greenWF">green water footprint</option>
              <option value="blueWF">blue water footprint</option>
              <option value="greyWF">grey water footprint</option>
              <option value="wf">total water footprint</option>
            </select>
          </div>
        </div>
        <BarStackedChart v-if="data.values && data.values.length" id="main-stbar-chart" :data="data" :xAttrName="namePropertyName" style="min-height: 400px"></BarStackedChart>
  </div>
</template>

<script>
import BarStackedChart from "@/components/shared/BarStackedChart.vue"
import {
  countryCropsByCrop,
  basinCropsByCrop,
  scenarioCountries,
} from "@/services/entity-model.js"
import { assessment } from "@/services/assessment-model.js"
import * as _ from 'lodash'

export default {
  name: "BarChartCt",
  components: {
    BarStackedChart,
  },
  mounted() {
    this.updateData();
  },
  data() {
    return {
      orderPropertyName: "blueWF",
      data: {},
      assessment: assessment,
      countryCropsByCrop: countryCropsByCrop,
      basinCropsByCrop: basinCropsByCrop,
      scenarioCountries: scenarioCountries
    }
  },
  computed: {
    geographic() {
      return assessment.isGeographic() || (assessment.assessmentType.name == "hbasins");
    },
    cropText: function() {
      if (this.geographic) {
        if ((assessment.crop == null) || (assessment.crop.cropID == 100001)) {
          return "green, blue and grey water footprint of all sectors and crops";
        }
        if (assessment.crop.cropID == 10001) {
          return "green, blue and grey water footprint of agriculture (all crops)";
        }
        if ((assessment.crop.cropID == 10002) || (assessment.crop.cropID == 10003)) {
          return "blue and grey water footprint of the " + assessment.crop.name.toLowerCase() + " sector";
        }
        return "green, blue and grey water footprint of " + assessment.crop.name.toLowerCase();
      }
      if (assessment.assessmentType.name == "commodity") {
        return "green, blue and grey water footprint of your commodity, " + assessment.scenario.name + ",";
      }
      if (assessment.branding != "sbtn") {  // "business"
        return "blue and grey water footprint of your business, " + assessment.scenario.name + ",";
      }
      return "blue water footprint of your business, " + assessment.scenario.name + ",";
    },
    countryOrBasinText: function() {
      if (this.geographic) {
        if (assessment.assessmentType.name == "basins") {
          return " in " + assessment.getCountryOrBasinName(true) + ", compared to other river basins";
        }
        if (assessment.assessmentType.name == "countries") {
          return " in " + assessment.getCountryOrBasinName(true) + ", compared to other countries";
        }
        return ", per country";
      }
      return " per country";
    },
    namePropertyName() {
      return assessment.assessmentType.name == "basins" ? "basinName" : "countryName";
    }
  },
  methods: {
    updateData() {
      const idPropertyName = assessment.assessmentType.idPropertyName;
      const orderType = this.orderPropertyName === this.namePropertyName ? 'asc' : 'desc';
      let orderedData = null;
      let countriesOrBasins = null;

      if (assessment.assessmentType.name == "basins") {
        orderedData = this.basinCropsByCrop;
        countriesOrBasins = assessment.countriesOrBasins;
      } else if (["countries", "world", "crops"].includes(assessment.assessmentType.name)) {
        orderedData = this.countryCropsByCrop;
        countriesOrBasins = assessment.countriesOrBasins;
      } else {  // commodity, business
        orderedData = this.scenarioCountries;
        countriesOrBasins = [];
      }
      orderedData = _.orderBy(orderedData, [this.orderPropertyName], [orderType]);

      const selectedIds = _.map(countriesOrBasins, idPropertyName) || [];
      const selectedNames = _.map(countriesOrBasins, 'name') || [];
      const data = {
        selected: orderedData.filter(i => selectedIds.includes(i[idPropertyName])),
        others: orderedData.filter(i => !selectedIds.includes(i[idPropertyName]))
      }
      this.data = { selected: selectedIds, values: _.concat(data.selected, data.others), selectedNames: selectedNames };
    }
  },
  watch: {
    "countryCropsByCrop": {
      handler: function () {
        this.updateData();
      },
      deep: true
    },
    "basinCropsByCrop":{ 
      handler: function () {
        this.updateData();
      },
      deep: true
    },
    "scenarioCountries":{ 
      handler: function () {
        this.updateData();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.form-select {
    font-size: inherit;
}
</style>
